import { render, staticRenderFns } from "./help.vue?vue&type=template&id=706de22c&scoped=true&"
import script from "./help.js?vue&type=script&lang=js&"
export * from "./help.js?vue&type=script&lang=js&"
import style0 from "./help.css?vue&type=style&index=0&id=706de22c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "706de22c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText,VCardTitle})
